import { AuthContext } from 'context/AuthContext';
import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function useMe(hasToken) {
  const fetchContext = useContext(FetchContext);
  const authContext = useContext(AuthContext);
  const { privateFetch } = fetchContext;

  async function getME() {
    return privateFetch.get(`/v1/me`).then((res) => res.data);
  }

  return useQuery('ME', getME, {
    enabled: hasToken,
    onSuccess() {
      authContext.setIsAuthenticated(true);
    },
  });
}

export default useMe;
